<div class="modal-header">
  <h4 class="modal-title pull-left">{{(IsEditMode ? "Edit Prospect" : "Add Prospect")}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="prospectForm" autocomplete="off" #formDir="ngForm" class="property-form margin-top-30" name="form">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div class="form-group">
          <label class="form-label">
            First Name
          </label>
          <input [attr.disabled]="disableProspectDetails ? '' : null" placeholder="First Name" formControlName="txtProspectName" type="text" maxlength="50" [(ngModel)]="prospectModel.FirstName" class="form-control ">
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div class="form-group">
          <label class="form-label">
            Last Name<span class="star">*</span>
          </label>
          <input [attr.disabled]="disableProspectDetails ? '' : null" placeholder="Last Name" formControlName="txtLastName" type="text" maxlength="50" [(ngModel)]="prospectModel.LastName" class="form-control " [required]>
          <div *ngIf="(txtLastName.invalid && isSubmitted )||(txtLastName.invalid && (txtLastName.dirty || txtLastName.touched))">
            <p class="redtext" *ngIf="txtLastName.errors.required">
              Last Name is required
            </p>
            <p class="redtext" *ngIf="txtLastName.errors.spaceOnly">
              The value cannot be only white spaces
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div class="form-group">
          <label class="form-label">Email<span class="red">*</span></label>
          <input [attr.disabled]="!allowEmailEdit ? '' : null" class="form-control" formControlName="emailinput" (change)="validateemail()" [(ngModel)]="prospectModel.Email" required type="text" maxlength="100">
          <p class="redtext" *ngIf="(emailValid) && emailinput.invalid && emailinput.touched">Email is required</p>
          <p class="redtext" *ngIf="(!emailValid) && emailvalidation ==''">Email is required</p>
          <p class="redtext" *ngIf="(emailvalidation!='' && prospectModel.Email!='')">{{emailvalidation}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="form-group autocomplete-design">
          <label class="form-label">Account Name<span class="star">*</span></label>
          <!--<ng2-completer [disableInput]="disableProspectDetails" formControlName="txtAccountName" [(ngModel)]="prospectModel.AccountName" [textSearching]="prospectModel.AccountName" [maxChars]="90" [datasource]="dataService"
                 (selected)="onAccountSelect($event)" [overrideSuggested]="true" [minSearchLength]="0"></ng2-completer>-->
          <!--<ng-select [(ngModel)]="prospectModel.AccountName" [items]="dataService" [disableInput]="disableProspectDetails" class="form-control" [searchable]="true" [virtualScroll]="true" [minTermLength]="0" (change)="onAccountSelect($event)"></ng-select>-->
          <ng-select [items]="dataService$ | async"
                     bindLabel="Name"
                     bindValue="Name"
                     formControlName="txtAccountName"
                     [hideSelected]="true"
                     [loading]="loading"
                     (change)="onAccountSelect($event)"
                     [typeahead]="dataServiceInput$"
                     [minTermLength]="0"
                     [(ngModel)]="prospectModel.AccountName">
          </ng-select>
          <div *ngIf="(txtAccountName.invalid && isSubmitted )||(txtAccountName.invalid && (txtAccountName.dirty || txtAccountName.touched))">
            <p class="redtext" *ngIf="txtAccountName.errors.required">
              Account Name is required
            </p>
          </div>
          <div role="group">
            <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
              <h5 class="mr-auto margin-bottom-5 info-box">
                <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
                  <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
                </i>
                <span><b style="font-weight:normal">If the account is not selected, it will be linked to account <b>'Other'</b>.</b></span>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="form-group">
          <label class="form-label">
            Status<span class="star">*</span>
          </label>
          <label class="select">
            <select class="form-control" formControlName="lstStatus"
                    [(ngModel)]="prospectModel.Status">
              <option [ngValue]="null" disabled selected hidden>Select</option>
              <option [ngValue]="item.id" *ngFor="let item of statusList">{{item.description}}</option>
            </select>
            <i></i>
          </label>
          <div *ngIf="(lstStatus.invalid && isSubmitted )||(lstStatus.invalid && (lstStatus.dirty || lstStatus.touched))">
            <p class="redtext" *ngIf="lstStatus.errors.required">
              Status is required
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div class="form-group checkbox-margin-top">
          <label class="form-label hidden-xs">&nbsp;</label>
          <div class="d-flex">
            <label class="custom-checkbox margin-right-20 margin-bottom-0 margin-right-15" for="checkboxOMDownloads">
              <input [attr.disabled]="prospectModel.IsOmOrNda ? true: null" type="checkbox" formControlName="chkOMDownloads" [(ngModel)]="prospectModel.OMDownloads" id="checkboxOMDownloads" />
              <!--OM Downloads-->OM Downloaded
              <i></i>
            </label>
            <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxNDAExecuted">
              <input [attr.disabled]="prospectModel.IsOmOrNda ? true: null" type="checkbox" formControlName="chkNDAExecuted" [(ngModel)]="prospectModel.NDAExecuted" id="checkboxNDAExecuted" />
              NDA Executed
              <i></i>
            </label>
          </div>

        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div class="form-group">
          <label class="form-label hidden-xs hidden-sm">Property Type</label>
          <div role="group" aria-labelledby="_isFranchisee" class="form-radio">
            <div class="radio radio-inline">
              <label>
                <input [checked]="prospectModel.OfferOnId == 6001" name="rdPropertyType" (change)="onPropertyTypeChange(6001)" type="radio">
                <i class="helper"></i>Property
              </label>
            </div>
            <div class="radio radio-inline">
              <label>
                <input name="rdPropertyType" [checked]="prospectModel.OfferOnId == 6002" (change)="onPropertyTypeChange(6002)" type="radio">
                <i class="helper"></i>Portfolio
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div class="form-group" *ngIf="prospectModel.Status == 5007">
          <label class="form-label">
            Feedback
          </label>
          <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown feedback-dropdown">
            <mat-form-field>
              <mat-select (click)="addClassToOverlayContainer()" formControlName="lstFeedback" placeholder="Select Feedback" [(ngModel)]="prospectModel.Feedback" [ngModelOptions]="{standalone: true}" multiple>
                @if (prospectModel.Feedback!=null && prospectModel.Feedback.length > 1) {
                <mat-select-trigger (click)="$event.stopPropagation()">
                  <span>{{ prospectModel?.Feedback.length }} items selected</span>
                </mat-select-trigger>
                }
                @for (feedback of feedackList; track feedback) {
                <mat-option [value]="feedback.id" class="multi-dropdown-item">{{feedback.name}}</mat-option>
                }
                <mat-option class="matoptionnodata" *ngIf="feedackList?.length === 0" disabled>
                  Nothing found...
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="form-label">
        Notes
      </label>
      <input placeholder="Notes" formControlName="txtNotes" type="text" maxlength="500" [(ngModel)]="prospectModel.Notes" class="form-control ">
    </div>
    <div class="form-group docs-list" *ngIf="prospectModel.NDAExecuted">
      <label class="form-label">Documents</label>
      <ng-container *ngFor="let doc of documents; let i= index">
        <p>
          <label>{{i + 1}} </label>
          <a *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">{{doc.name}}</a>
          <span style="cursor:none !important" *ngIf="doc.Url == null || doc.Url == undefiend || doc.Url.length == 0">{{doc.name}}</span>
          <span (click)="onRemoveDocuments(doc.Id)" tooltip="Remove" class="remove">
            <i aria-hidden="true" class="icofont icofont-close"></i>
          </span>
        </p>

      </ng-container>
    </div>
    <div class="form-group" *ngIf="prospectModel.NDAExecuted">
      <file-upload [fileDocExt]="'pdf,jpeg,jpg'" [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
    </div>

    <div class="form-group">
      <div class="text-right">
        <button type="button" (click)="onClose()" class="btn btn-default btn-lg">Cancel</button>
        <button type="button" (click)="saveDetails(SaveProspectConfirmation,'deletemodal')" class="btn btn-success btn-lg">Save</button>
      </div>

    </div>

  </form>
</div>

<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Update NDA Document ?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="removeModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">


    <div class="form-group">
      <h6 class="displayvalue">Are you sure to update NDA document ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="removeModalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onRemoveDocuments(removeId);removeModalRef.hide();">Update</button>
    </div>
  </div>
</ng-template>

<ng-template #SaveProspectConfirmation>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Save Prospect</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">


    <div class="form-group">
      <h6 class="displayvalue">A prospect with the same email address is already exists in the system.Are you sure you want to proceed with the existing one?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="ConfirmSaveProspects(SaveProspectConfirmation,'deletemodal')">Proceed</button>
    </div>
  </div>
</ng-template>
